import React from 'react';
import { Typography } from 'antd';
import Icon from '@ant-design/icons';
import styles from './Overlay.module.less';
import { CustomIconComponentProps } from '@ant-design/icons/es/components/Icon';

type OverlayProps = {
  text?: string;
  customIcon?:
    | React.ComponentType<CustomIconComponentProps | React.SVGProps<SVGSVGElement>>
    | React.ForwardRefExoticComponent<CustomIconComponentProps>;
};

const Overlay = ({ customIcon, text }: OverlayProps) => (
  <div className={styles.mapOverlay}>
    <div className={styles.mapOverlayCaption}>
      {customIcon && <Icon className={styles.mapOverlayIcon} component={customIcon} />}
      <Typography.Text className={styles.mapOverlayText} strong>
        {text}
      </Typography.Text>
    </div>
  </div>
);

export default Overlay;
